export const DEPARTMENTS = [
  "Human Resources",
  "Technology",
  "Marketing",
  "Sales",
  "Training",
  "Operations",
  "Design",
] as const;

export type Department = (typeof DEPARTMENTS)[number];